module.exports = __webpack_public_path__ + "img/register-passkey-successfully.95a39630.png";